import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "3109b76f-dc76-4928-8934-f0901735bfe8",
    label: "DG(P&S) Office Order Ref. No. DG/P&S/300./2021-2022",
    date: "31/12/2022",
    subject:
      'GUIDELINE FOR ISSUANCE OF "No-OB.JECTION CERTIFICATE" RELATED TO CUTTING / FELLING OF TREES UNDER PARKS & SQUARES DEPARTMENT',
  },
  {
    fileStoreId: "0e3d52cc-222a-4fab-aa09-6a7c44c3b18a",
    label: "DG(BLDG)'s Circular No. 08 of 2021-2022",
    date: "25/11/2021",
    subject:
      "Statutory warning (reminder) for prevention of air pollution by construction industries specially during winter months Circular No. 08 of 2021-22",
  },
  {
    fileStoreId: "ad1e9299-97bd-409b-8c9e-3aa777b854b7",
    label: "DG(BLDG)'s Circular No. 07 of 2021-2022",
    date: "25/11/2021",
    subject:
      "Management of Dilapidated building us 412A Circular No. 07 of 2021-22",
  },
  {
    fileStoreId: "453690d7-7276-4fdd-8041-99e715956fbd",
    label: "DG(BLDG)'s Circular No. 06 of 2021-2022",
    date: "09/11/2021",
    subject: "Size of lift Circular No. 06 of 2021-22",
  },
  {
    fileStoreId: "8c0d99a2-9fc2-4693-ae89-32af1f4a582f",
    label: "DG(BLDG)'s Circular No. 05 of 2021-2022",
    date: "08/11/2021",
    subject:
      "NOC from Water supply and Drainage Department Circular No. 05 of 2021-22",
  },
  {
    fileStoreId: "c9df4783-0ada-406d-871f-ac6f922ca4f2",
    label: "DG(BLDG)'s Circular No. 04 of 2021-2022",
    date: "25/08/2021",
    subject: "Mobile Tower online permission Circular No. 04 of 2021-22",
  },
  {
    fileStoreId: "3ae366c4-daa5-4e52-96af-647f9a656eb5",
    label: "DG(BLDG)'s Circular No. 03 of 2021-2022",
    date: "13/08/2021",
    subject: "Time extension Circular No. 03 of 2021-22",
  },
  {
    fileStoreId: "c1c681d5-006a-4808-8d20-d95bdf2fc519",
    label: "DG(BLDG)'s Circular No. 02 of 2021-2022",
    date: "27/07/2021",
    subject: "FAR touching EM Bye pass Circular No. 02 of 2021-22",
  },
  {
    fileStoreId: "b2dd4c28-907f-4d47-9a64-a804db134c6c",
    label: "DG(BLDG)'s Circular No. 01 of 2021-2022",
    date: "27/07/2021",
    subject: "Renual of building plan Circular No. 01 of 2021-22",
  },
];

const Building_Sanction_Circular_2021_22 = () => (
  <TableStructure
    list={List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2021-22"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2021_22;
